import * as React from "react";

import { TreeSelect } from "kanopi-components/TreeSelect";

type TStatelessAnzsicCodeInput = {
  codes: unknown[];
  filterDivisions: string;
  loading: boolean;
  value: unknown;
};

export const StatelessAnzsicCodeInput: React.FC<TStatelessAnzsicCodeInput & unknown> = (
  props
) => {
  const { codes, filterDivisions, loading, value, ...restProps } = props;
  const options = React.useMemo(
    () => transformCodes(codes, ["subdivisions", "groups", "classes"], filterDivisions),
    [codes, filterDivisions]
  );
  /*
   * The value parameter can be in both dict and str types. When the anzsic code comes
   * from the database the value param will be a dict. Ex: {code: 3-259}. When the anzsic
   * code comes from the UI component it will be a str. Ex: "3-259"
   * */
  return (
    <TreeSelect
      options={options}
      placeholder="Type to search..."
      disabled={loading}
      isLoading={loading}
      searchable
      value={value?.code || value}
      {...restProps}
    />
  );
};

function transformCodes(data, childKeys, filterDivisions, parent, depth = 0) {
  const childKey = childKeys[0];
  const nextChildKeys = childKeys.slice(1);
  return (data || []).filter(filterDivisionsByCode(filterDivisions, depth)).map((o) => {
    const id = `${depth}-${o.id}`;
    const node = {
      ...o,
      id,
    };
    if (parent) {
      node.parent = parent;
    }
    node.children = transformCodes(
      o[childKey] || [],
      nextChildKeys,
      filterDivisions,
      node,
      depth + 1
    );
    return node;
  });
}

function filterDivisionsByCode(filter, depth) {
  return (division) => {
    if (depth !== 0 || !filter) {
      return true;
    }
    return division?.code == filter;
  };
}
